import { createFileRoute } from '@tanstack/react-router'
import CollegeDrivesInbox from '@/pages/drives'

export const Route = createFileRoute('/_authenticated/drives/')({
  component: CollegeDrivesInbox,
})
